import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';
import { UscModalComponent } from '../usc-modal/usc-modal.component';

import { UscImpressionComponent } from '../usc-impression/usc-impression.component';

@Component({
  selector: 'sn-usc-middle',
  templateUrl: '../usc-impression/usc-impression.component.html',
  styleUrls: ['../usc-store.component.css', './usc-middle.component.css']
})
export class UscMiddleComponent extends UscImpressionComponent {

  public orderBy:string = this.uscStoreService.isUSCellRetail() ? "me_date" : "ca_date";
  view:string = this.uscStoreService.view_middle;
  public view_no_purchase:string = this.uscStoreService.form_no_purchase;
  public view_reschedule:string = this.uscStoreService.form_reschedule;
  public view_new_call:string = this.uscStoreService.form_new_call;
  public view_file_upload:string = this.uscStoreService.form_file_upload;

  processOutcome(item, outcome) {
    if (outcome == this.transition_no_show) {
      this.showPromptDlg(item, outcome);
    } else {
      super.processOutcome(item, outcome);
    }
  }

  showOutcomeLog(item, outcome) {
    const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.view = outcome;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
    modalRef.result.then((result) => {
      if (outcome == this.view_purchase || outcome == this.view_no_purchase) {
        this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
    //   2024-04-09: removed as per USCC
    //   } else if (outcome == this.view_future_sales) {
    //     this.showPromptDlg(item, this.transition_new_referral);
      } else if (outcome == this.view_reschedule) {
        if (this.isUSCellRetail) {
          var cfd_fumd = result.data.find(d => d.key == 'cfd_fumd');
          if (cfd_fumd) {
            var date = new Date(cfd_fumd.value); // this will convert date value to localtime 
            var today = new Date();
            // compare UTC date to today instead due to javascript converts to localtime 
            if (date.getUTCFullYear() == today.getFullYear() && date.getUTCMonth() == today.getUTCMonth() && date.getUTCDate() == today.getDate()) {
              this.uscStoreService.setViewItemUpdated(item);
              this.openOkDialog('Please alert other Associates within your store that you have booked a same-day appointment.', true);
            } else {
              this.uscStoreService.setViewItemUpdated(item);
              this.reloadItems();
            }
          }
        }
      } else {
        this.pageItemsChecked = false;
        this.uscStoreService.setViewItemUpdated(item);
        this.reloadItems();
      }
    }, (reason) => {
    //   2024-04-09: removed as per USCC
    //   if (outcome == this.uscStoreService.form_future_sale) {
    //     this.showPromptDlg(item, this.transition_new_referral);
    //   }
    });
  }
}




// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-middle/usc-middle.component.ts